module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "event-selection"
    }
  }, [_c('div', {
    staticClass: "modal fade in",
    staticStyle: {
      "display": "block"
    }
  }, [(_vm.teamNameFromUrl && _vm.error) ? _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.game.comments && _vm.game.comments.intro) ? _c('small', [_vm._v(_vm._s(_vm.game.comments.intro))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-danger mb-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.error')))]), _vm._v(" " + _vm._s(_vm.$t('errors.' + _vm.error)) + "\n                    ")])])])]) : _vm._e(), _vm._v(" "), (!_vm.teamNameFromUrl) ? _c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.event.title))]), _vm._v(" "), (_vm.game.comments && _vm.game.comments.intro) ? _c('small', [_vm._v(_vm._s(_vm.game.comments.intro))]) : _vm._e()]), _vm._v(" "), (!_vm.teamNameFromUrl) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.enter()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('team_selection.enter_team_name')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teamName),
      expression: "teamName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('team_selection.team_name')
    },
    domProps: {
      "value": (_vm.teamName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teamName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.loading
    }
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-refresh fa-fast-spin': _vm.loading, 'fa-sign-in': !_vm.loading
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.enter')) + "\n                                    ")])])])]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('common.error')))]), _vm._v(" " + _vm._s(_vm.$t('errors.' + _vm.error)) + "\n                        ")]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.recentTeam) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        (_vm.teamName = _vm.recentTeam.name) && _vm.resumeRecentTeam()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-repeat",
    class: {
      'fa-fast-spin': _vm.loading && _vm.loadingName === _vm.recentTeam.name
    },
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('team_selection.continue_as_team', {
        team: '<strong>' + _vm.recentTeam.name + '</strong>'
      }))
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right text-muted",
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.exit()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('common.cancel')) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e()])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop fade in"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d18020b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team_selection.vue
// module id = 374
// module chunks = 0